import EditNewsModal from './EditNewsModal';

export default EditNewsModal;
